export const notfound = {
  'seo.title': '404 — Side ikke funnet | Sofia & Elena',
  'seo.description': 'Siden du leter etter ble ikke funnet.',
  'seo.keywords': '404, side ikke funnet',
  'title': 'Side ikke funnet',
  'description': 'Siden du leter etter eksisterer ikke eller har blitt flyttet.',
  'button': 'Tilbake til hjemmesiden',
  'buttonAria': 'Gå tilbake til hjemmesiden',
};